module.exports = __webpack_public_path__ + "img/pokeball.2b4673e3.png";